export default "__VITE_ASSET__D5FScT8n__"